import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

const convertServerOriginToCartURL = (url: string) => {
  switch (url) {
    case 'https://dev-api.skin-seoul.com':
      return 'https://dev.skin-seoul.com/api';
    case 'https://staging-api.skin-seoul.com':
      return 'https://staging.skin-seoul.com/api';
    case 'https://api.skin-seoul.com':
      return 'https://skin-seoul.com/api';
    default:
      return 'https://dev.skin-seoul.com/api';
  }
};

export const createSkinSeoulCartClient = (_baseURL?: string): AxiosInstance => {
  const baseURL = convertServerOriginToCartURL(_baseURL ?? env('NEXT_PUBLIC_ENV_SERVER_ORIGIN'));

  // Debug logging for environment context
  const isServer = typeof window === 'undefined';
  const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

  console.debug('[service/client] Creating HTTP client:', {
    isServer,
    hasGlobalEnv,
    baseURL,
    envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
  });

  return axios.create({
    baseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });
};

export let cartClient: AxiosInstance = createSkinSeoulCartClient();

export const setCartClient = (instance: AxiosInstance) => {
  cartClient = instance;
};
